let startX;
let scrollLeft;
let isDown = false
function cusorGrabingMousedown(slider, e){
  isDown = true;
  slider.classList.add('active');
  startX = e.pageX - slider.offsetLeft;
  scrollLeft = slider.scrollLeft;
}

function cusorGrabingMouseleave(slider, e){
  isDown = false;
  slider.classList.remove('active');
}

function cusorGrabingMouseup(slider, e){
  isDown = false;
  slider.classList.remove('active');
}

function cusorGrabingMousemove(slider, e){
  if(!isDown) {return};
  e.preventDefault();
  const x = e.pageX - slider.offsetLeft;
  const walk = (x - startX) * 1; //scroll-fast
  slider.scrollLeft = scrollLeft - walk;
}

function closeSizeGuild(btn){
  btn.closest('.modal-cs').classList.remove('active');
}

function openSizeGuild(){
  document.querySelector('modal-sizeguild.modal-cs').classList.add('active');
}
class tabsContent extends HTMLElement {
    connectedCallback() {
        this.tabsItem = this.querySelectorAll('.tabs-page-list .tab-title');
        this.tabsItem.forEach(tabItem => {
            tabItem.addEventListener('click', (event) => this.TabStart(event, tabItem), false);
        });
    }
    TabStart(event, tabItem) {
        var tabId = tabItem.getAttribute('data-tabs-id');
        this.tabsItem.forEach(tabItemzz => {
          tabItemzz.classList.remove('active');
      });
      tabItem.classList.add('active');
        var tabsContentContain = tabItem.closest('.content-list');

        if (tabsContentContain) {
            var tabContent = tabsContentContain.querySelector(`#${tabId}`);
            var tablesItem = tabsContentContain.querySelectorAll('.table-list .table-item');
            tablesItem.forEach(tableItem => {
                tableItem.classList.add('hidden');
            });
            if (tabContent) {
                tabContent.classList.remove('hidden');
            }
        }
    }
}

customElements.define('tabs-content', tabsContent);

class tableContent extends HTMLElement {
  connectedCallback() {
    this.tablesItem = this.querySelectorAll('tbody tr td:first-child');
    const firstColumnDiv = this.querySelector('.first-column');
    this.tablesItem.forEach(tableItem => {
      const content = tableItem.textContent;
      const span = document.createElement('span');
      span.textContent = content;
      const div = document.createElement('div');
      div.classList.add('first-col');
      div.appendChild(span);
      firstColumnDiv.appendChild(div);
      tableItem.remove();
    });
    var swiperMetafields = this.querySelector('.table-column');
    setTimeout(() => {
      var swiper = new Swiper(swiperMetafields, {
        slidesPerView: 'auto',
        setWrapperSize: false,
        autoHeight: true,
        freeMode: true,
        grabCursor: true,
        scrollbar: {
          el: ".swiper-scrollbar",
        },
    });
    }, 1000);
  }
}

customElements.define('table-content', tableContent);
